import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import { StyledSinglePaletteIconComponent } from "./palette-icons-component.scss";
import SinglePaletteIconComponent from "./single-palette-icon/single-palette-icon-component";
class PaletteIconsComponent extends PureComponent {
    renderSocialMediaIcons() {
        const { SocialFooterLinks } = this.props;
        const socialMediasIcons = SocialFooterLinks.links;
        return Object.keys(socialMediasIcons).map((key)=>{
            const socialMediaIcon = socialMediasIcons[key];
            const IconComp = socialMediaIcon.iconV2;
            return /*#__PURE__*/ _jsx("div", {
                className: "single-social-icon-wrapper",
                children: /*#__PURE__*/ _jsx(SinglePaletteIconComponent, {
                    IconComp: IconComp,
                    clickableLink: socialMediaIcon.url,
                    title: socialMediaIcon.title
                })
            }, key);
        });
    }
    render() {
        return /*#__PURE__*/ _jsx(StyledSinglePaletteIconComponent, {
            className: "palette-icons-container",
            children: /*#__PURE__*/ _jsx("div", {
                className: "icons-wrapper",
                children: this.renderSocialMediaIcons()
            })
        });
    }
}
export { PaletteIconsComponent as default };
